// src/components/ForceChangePassword.jsx
// Shown when an admin logs in with a temporary password (must_change_password = true).
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const ForceChangePassword = () => {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) { setError('New password must be at least 8 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE}/api/auth/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        // Update the locally stored user so the flag is cleared for this session
        try {
          const stored = JSON.parse(localStorage.getItem('user') || '{}');
          stored.mustChangePassword = false;
          localStorage.setItem('user', JSON.stringify(stored));
        } catch (err) { /* ignore */ }
        // Redirect based on role
        try {
          const stored = JSON.parse(localStorage.getItem('user') || '{}');
          navigate(stored.role === 'super_admin' ? '/super-admin' : '/admin', { replace: true });
        } catch (err) {
          navigate('/admin', { replace: true });
        }
      } else {
        setError(data.error || 'Failed to change password');
      }
    } catch (err) {
      setError('Cannot connect to server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container login">
        <div className="auth-header">
          <p>You must change your password before continuing.</p>
        </div>
        <div className="auth-form-container">
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Current password</label>
              <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} placeholder="Temporary password" required />
            </div>
            <div className="form-group">
              <label>New password</label>
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="At least 8 characters" required />
            </div>
            <div className="form-group">
              <label>Confirm new password</label>
              <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Re-enter new password" required />
            </div>
            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Changing...' : 'Change password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForceChangePassword;
